import type { PlayerRole } from "../../api/types";

export interface SkillParams {
  gender: "M" | "F";
  roles: PlayerRole[];
  attack: number;
  defense: number;
  serve: number;
  wall: number;
  setting: number;
  personality: number;
  seniority: number; // anni di anzianità in squadra
  presence: number;
}

/** Anzianità (1..12 anni) riportata sulla scala 60..100, come Player.getNormalizedSeniority() */
function normalizedSeniority(years: number): number {
  const clamped = Math.max(1, Math.min(12, years));
  return Math.ceil(60 + ((clamped - 1) * 40) / 11);
}

/** Porting di Player.roleWeightedScore() del backend */
function roleWeightedScore(p: SkillParams, role: PlayerRole): number {
  const wall = p.gender === "F" || role === "PALLEGGIO" ? 60 : p.wall;
  const setting = role === "PALLEGGIO" ? p.setting : Math.max(60, p.setting * 0.6);
  const seniority = normalizedSeniority(p.seniority);
  const { attack, defense, serve, personality, presence } = p;

  switch (role) {
    case "OPPOSTO":
      return attack * 0.35 + defense * 0.15 + serve * 0.15 + wall * 0.15 + setting * 0.05 +
        personality * 0.1 + seniority * 0.05 + presence * 0.05;
    case "CENTRALE":
      return attack * 0.25 + defense * 0.2 + serve * 0.1 + wall * 0.3 + setting * 0.05 +
        personality * 0.1 + seniority * 0.05 + presence * 0.05;
    case "PALLEGGIO":
      return attack * 0.1 + defense * 0.25 + serve * 0.15 + wall * 0.05 + setting * 0.3 +
        personality * 0.1 + seniority * 0.05 + presence * 0.05;
    default: // BANDA (e LIBERO)
      return attack * 0.3 + defense * 0.25 + serve * 0.15 + wall * 0.1 + setting * 0.05 +
        personality * 0.1 + seniority * 0.05 + presence * 0.05;
  }
}

/** Skill base (senza statistiche dinamiche): media dei punteggi sui ruoli del giocatore */
export function computeBaseSkill(p: SkillParams): number {
  const roles: PlayerRole[] = p.roles.length > 0 ? p.roles : ["BANDA"];
  const avg = roles.reduce((sum, r) => sum + roleWeightedScore(p, r), 0) / roles.length;
  return Math.ceil(avg);
}
